import React from 'react';
import Skeleton from 'react-loading-skeleton';

const ActionCardSkeleton = () => (
  <>
    {/* Mobile: compact horizontal row (matches sm:hidden in ActionCard) */}
    <div className="sm:hidden flex items-center gap-3 pl-4 pr-6 py-4 rounded-2xl border-2 border-border bg-background-secondary">
      <Skeleton circle width={48} height={48} className="flex-shrink-0" />
      <div className="flex-grow min-w-0">
        <div className="mb-1"><Skeleton width="50%" height={14} /></div>
        <Skeleton width="70%" height={12} />
      </div>
      <Skeleton width={28} height={28} className="flex-shrink-0" />
    </div>

    {/* Desktop: full card (matches hidden sm:block in ActionCard) */}
    <div className="hidden sm:flex relative h-full flex-col p-6 rounded-2xl bg-background-secondary border-2 border-border">
      {/* Mascot image top-right */}
      <div className="absolute top-4 right-4 z-10">
        <Skeleton circle width={64} height={64} />
      </div>

      {/* Title + description */}
      <div className="relative z-10 flex-grow">
        <div className="mb-4">
          <h3 className="text-xl font-bold mb-2 leading-tight">
            <Skeleton width="60%" />
          </h3>
          <p className="opacity-90 text-sm leading-relaxed font-medium">
            <Skeleton width="80%" />
          </p>
        </div>
      </div>

      {/* Count + CTA */}
      <div className="relative z-10 mt-6 flex items-end justify-between">
        <div className="flex flex-col">
          <div className="text-3xl font-black leading-none mb-1">
            <Skeleton width={40} />
          </div>
          <div className="text-xs opacity-80 font-semibold uppercase tracking-wide">
            <Skeleton width={30} />
          </div>
        </div>
        <div className="font-semibold text-sm">
          <Skeleton width={80} height={24} />
        </div>
      </div>
    </div>
  </>
);

export default ActionCardSkeleton;
